export enum ConfigState {
  New = "new",
  Existing= "existing"
}
